<template>

<section class="gallery-section">
  <h2 class="gallery-title">Upptäck The Lounge Bar</h2>
  <div class="gallery-container">
    <div class="gallery-item">
      <img src="/assets/img-section1.png" alt="Räksallad" />
    </div>
    <div class="gallery-item">
      <img src="/assets/img-section4.png" alt="Kött och pommes" />
    </div>
    <div class="gallery-item">
      <img src="/assets/img-section3.png" alt="Bar med cocktails" />
    </div>
    <div class="gallery-item">
      <img src="/assets/img-section2.png" alt="Grillad mat" />
    </div>

  </div>
</section>

</template>


<style>
/* Sektionens stil */
.gallery-section {
  background-color:#1a1a1a; /* Mörk bakgrund */
  padding: 4rem 1rem;
  text-align: center;
  color: #f5f5f5;
}

.gallery-title {
  font-size: 2.5rem;
  color: #937d51; /* Guld för premiumkänsla */
  margin-bottom: 2rem;
}

/* Galleri-layout */
.gallery-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); /* Flexibel layout */
  gap: 1.5rem; /* Mellanrum mellan bilder */
  padding: 0 1rem;
}

/* Galleri-bilder */
.gallery-item {
  position: relative;
  overflow: hidden;
  border-radius: 8px; /* Runda hörn */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Fyll området snyggt */
  transition: transform 0.3s ease, filter 0.3s ease;
}

.gallery-item:hover img {
  transform: scale(1.1); /* Zoomar in vid hover */
  filter: brightness(80%); /* Mörkar ned bilden något */
}

/* Textöverlägg vid hover */
.gallery-item::after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.5rem;
  background: rgba(0, 0, 0, 0.7);
  color: #f5f5f5;
  font-size: 1rem;
  text-align: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.gallery-item:hover::after {
  opacity: 1; /* Visa text vid hover */
}
</style>